import { ModalBody } from '@chakra-ui/react'
import { useQuery } from '@tanstack/react-query'
import { FC, useEffect } from 'react'
import { fetchTankInfo } from '../api/tankInfo/tankInfo.service'
import { tankOrder, waterOrder, fishOrder } from '../components/tankInfo/constant'
import TankInfoCardContainer from '../components/tankInfo/TankInfoCardContainer'
import { TankInfoLiveContainer } from '../components/tankInfo/TankInfoLiveContainer'
import TankInfoTitle from '../components/tankInfo/Title'
import { useTankInfoModalStore } from '../store/tankInfo/useTankInfoModalStore'

export const TankInfo: FC = () => {
  const { tankId, tankName, initialHlsUri, initialPosition, setTankInfo, setIsLoading } =
    useTankInfoModalStore()

  // Service를 통해 Domain 모델로 변환된 데이터 조회
  const { data: tankInfo, isLoading } = useQuery({
    queryKey: ['tankInformation', tankId],
    queryFn: () => fetchTankInfo(tankId),
    enabled: !!tankId,
  })

  // Sync React Query state to Zustand store (이미 Domain 모델)
  useEffect(() => {
    setTankInfo(tankInfo ?? null)
  }, [tankInfo, setTankInfo])

  useEffect(() => {
    setIsLoading(isLoading)
  }, [isLoading, setIsLoading])

  // 모든 카드를 항상 표시
  const tankCardNames = tankOrder
  const waterCardNames = waterOrder
  const fishCardNames = fishOrder

  return (
    <ModalBody p={0} px={{ base: 1, md: 5 }}>
      <TankInfoTitle tankId={tankId} tankName={tankName} />
      <TankInfoCardContainer tankId={tankId} title="Tank" cardNames={tankCardNames} />
      <TankInfoCardContainer tankId={tankId} title="Water" cardNames={waterCardNames} />
      <TankInfoCardContainer tankId={tankId} title="Fish" cardNames={fishCardNames} />
      {tankId && (
        <TankInfoLiveContainer
          tankId={tankId}
          initialHlsUri={initialHlsUri}
          initialPosition={initialPosition}
        />
      )}
    </ModalBody>
  )
}
